import {removeStoredContactField} from '../../storage';
import { BaseWidgetProps } from '../../widget-container';
import * as React from 'react';

export type ContactActionBoxProps = {
	baseConfig: BaseWidgetProps,
	doneBtnText: string,
	clickBtn?: () => void,
	linkData?: {
		link: string,
		target?: string
	}
};

export class ContactActionBox extends React.Component<ContactActionBoxProps, any> {

	constructor (props: ContactActionBoxProps) {
		super(props);
	}

	render () {
		const {linkData, clickBtn, doneBtnText} = this.props;
		const linkTarget = !!linkData && linkData.target ? linkData.target : '_blank';

		removeStoredContactField();
		return (
			<div className='contact-action-box'>
				<div className='ticket-message-box'>
					{this.props.children}
				</div>
				{clickBtn ? <button className={'done-button'} onClick={clickBtn}>{doneBtnText}</button> : null}
				{linkData ? <a className={'done-button'} href={linkData.link} target={linkTarget}>{doneBtnText}</a> : null}
			</div>
		);
	}
}
